const getCurrentPage = async ({ results, page }) => {
    if (page != 1 && results?.length == 1) { page -= 1 }
    return page
}

export default getCurrentPage;